import { jsx as _jsx } from "react/jsx-runtime";
import { LineContainer } from "./propertyLines/propertyLine";
import { UploadButton } from "../primitives/uploadButton";
/**
 * A full-width line with an upload button.
 * For just the button without the line wrapper, use UploadButton directly.
 * @returns An UploadButton wrapped in a LineContainer
 */
export const FileUploadLine = ({ onClick, label, accept, ...buttonProps }) => {
    FileUploadLine.displayName = "FileUploadLine";
    return (_jsx(LineContainer, { uniqueId: `${label}_upload`, label: label, children: _jsx(UploadButton, { onUpload: onClick, accept: accept, label: label, ...buttonProps }) }));
};
//# sourceMappingURL=fileUploadLine.js.map